module.exports = __webpack_public_path__ + "static/media/IKEDC.3d59565c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/discos/IKEDC.png
// module id = 373
// module chunks = 25